module.exports = __webpack_public_path__ + "static/media/03-reveal.65ab9839.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/instructiongifs/03-reveal.gif
// module id = 260
// module chunks = 0